/**
 * Soft, restrained chip tones so icon rows don't read as one monotone block.
 * Cycled by index across card lists.
 */
export interface IconTone {
  bg: string
  fg: string
}

export const iconTones: IconTone[] = [
  { bg: 'bg-forest-100', fg: 'text-forest-600' },
  { bg: 'bg-ember-100', fg: 'text-ember-600' },
  { bg: 'bg-[#D7EBE4]', fg: 'text-[#1B6B58]' },
  { bg: 'bg-[#E0E4F7]', fg: 'text-[#3D4A96]' },
  { bg: 'bg-[#F7DFD2]', fg: 'text-[#A0512A]' },
  { bg: 'bg-[#E2EBD9]', fg: 'text-[#456B3D]' },
]

export function toneAt(index: number): IconTone {
  return iconTones[index % iconTones.length]
}
